<template>
  <div class="products-list-page">
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12 pa-5>
        
        <!-- Page Header -->
        <div class="page-header mb-5">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon color="white" size="22">mdi-package-variant-closed</v-icon>
            </div>
            <div>
              <h2 class="page-title">Products</h2>
            </div>
          </div>
          <div class="header-actions" v-if="totalData">
            <div class="stat-chip">
              <v-icon size="14" color="#3ea56e" class="mr-1">mdi-package-variant</v-icon>
              <span>{{ totalData }} Total Products</span>
            </div>
          </div>
        </div>

        <!-- Main Card -->
        <v-card class="modern-card" elevation="0">
          
          <!-- Filters Bar -->
          <div class="filters-bar py-4 px-5">
            <v-row dense align="center">
              <!-- Search keyword -->
              <v-col cols="12" sm="4" class="py-1">
                <v-text-field
                  v-model="keyword"
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Search products..."
                  outlined
                  dense
                  hide-details
                  clearable
                  class="modern-input"
                ></v-text-field>
              </v-col>
              <!-- Main Category selector -->
              <v-col cols="12" sm="4" class="py-1">
                <v-select
                  v-model="mainCategory"
                  :items="mainCategoryArray"
                  item-text="mname"
                  item-value="value"
                  outlined
                  dense
                  hide-details
                  label="Main Category"
                  prepend-inner-icon="mdi-shape-outline"
                  class="modern-input"
                ></v-select>
              </v-col>
              <!-- Sub Category selector -->
              <v-col cols="12" sm="4" class="py-1">
                <v-select
                  v-model="category"
                  :items="categoryArray"
                  item-text="name"
                  item-value="_id"
                  outlined
                  dense
                  hide-details
                  label="Category"
                  prepend-inner-icon="mdi-shape"
                  class="modern-input"
                ></v-select>
              </v-col>
            </v-row>
          </div>

          <v-divider></v-divider>

          <!-- Product Grid -->
          <div class="grid-container pa-5" v-if="product && product.length > 0">
            <v-row>
              <v-col
                v-for="(item, i) in product"
                :key="i"
                cols="12"
                sm="6"
                md="4"
                lg="3"
                class="pa-3"
              >
                <v-card
                  class="product-grid-card h-100"
                  elevation="0"
                  @click="info(item._id)"
                >
                  <!-- Image Wrapper -->
                  <div class="product-img-wrap">
                    <v-img
                      v-if="item.photos && item.photos[0]"
                      :src="mediaURL + item.photos[0]"
                      height="180px"
                      contain
                      class="product-image"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="#3ea56e" size="24"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      src="./../../assets/noimg.png"
                      height="180px"
                      contain
                      class="product-image"
                    ></v-img>
                    
                    <!-- Low Stock Badge inside Image wrap -->
                    <div class="low-stock-badge-container" v-if="isLowStock(item)">
                      <span class="low-stock-badge">
                        Low Stock: {{ item.quantity }}
                      </span>
                    </div>
                  </div>

                  <!-- Product Content -->
                  <div class="product-info-content pa-3 text-center">
                    <h4 class="product-name" :title="item.productname">
                      {{ item.productname }}
                    </h4>
                    
                    <!-- Ratings -->
                    <div class="rating-wrap justify-center py-1">
                      <v-rating
                        v-model="item.rating"
                        color="#FFD341"
                        background-color="#e2e8f0"
                        empty-icon="$ratingFull"
                        half-increments
                        readonly
                        small
                        dense
                      ></v-rating>
                    </div>

                    <!-- Pricing Block -->
                    <div class="pricing-wrap mt-1">
                      <template v-if="item.offerPrice">
                        <span class="offer-price-val">Rs. {{ item.offerPrice }}</span>
                        <span class="original-price-val text-decoration-line-through ml-2">
                          Rs. {{ item.price }}
                        </span>
                      </template>
                      <template v-else>
                        <span class="regular-price-val">Rs. {{ item.price }}</span>
                      </template>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>

          <!-- Empty State -->
          <div class="empty-state" v-else>
            <v-icon size="56" color="#cbd5e1">mdi-package-variant</v-icon>
            <p class="empty-title">No products found</p>
            <p class="empty-subtitle">Try adjusting your filters or search criteria</p>
          </div>

          <!-- Pagination -->
          <div class="pagination-wrap" v-if="pages > 1">
            <div class="pagination-info">
              <span>Page {{ currentPage }} of {{ pages }}</span>
            </div>
            <v-pagination
              :length="pages"
              :total-visible="7"
              v-model="currentPage"
              color="#3ea56e"
              class="modern-pagination"
            ></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["sellerId"],
  data() {
    return {
      ServerError: false,
      appLoading: false,
      keyword: "",
      currentPage: 1,
      pages: 0,
      count: 12,
      totalData: 0,
      totalRows: 0,
      product: [],
      data: [],
      category: [],
      mainCategory: "",
      mainCategoryArray: [],
      categoryArray: [],
    };
  },
  watch: {
    keyword() {
      this.getSearch();
    },
    currentPage() {
      this.getData();
    },
    mainCategory() {
      this.getSearch();
      this.getCategory();
      this.category = "";
    },
    category() {
      this.getSearch();
    },
  },
  mounted() {
    this.getData();
    this.getMainCategory();
  },
  methods: {
    getSearch() {
      axios({
        url: "/product/search",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          count: this.count,
          page: this.currentPage,
          keyword: this.keyword,
          maincategory: this.mainCategory,
          category: this.category,
        },
      })
        .then((response) => {
          this.product = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/product/all",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.product = response.data.data;
          this.pages = response.data.pages;
          this.data = response.data.data.category;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getMainCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/maincategory/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          var temp = [
            {
              mname: null,
              value: null,
            },
          ];
          temp = response.data.data;
          for (var i = 0; i < temp.length; i++) {
            temp[i].mname = temp[i].name;
            temp[i].value = temp[i]._id;
          }
          this.mainCategoryArray = temp;
          this.mainCategoryArray.unshift({ mname: "All", value: null });
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    getCategory() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/category/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          mainCategoryId: this.mainCategory,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.categoryArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    info(pid) {
      this.$router.push("/productDetails/" + pid);
    },
    edit(pid) {
      this.$router.push({ name: "editProduct", params: { productid: pid } });
    },
    isLowStock(item) {
      if (item.minimumOrderQuantity) {
        return item.quantity <= item.minimumOrderQuantity * 5;
      } else {
        return item.quantity < 10;
      }
    },
  },
};
</script>

<style scoped>
/* Page Wrapper */
.products-list-page {
  background: #f5f6fa;
  min-height: 100vh;
  font-family: poppinsmedium, sans-serif;
  width: 100%;
}

/* Page Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.header-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3ea56e, #2d8257);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.35);
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.2;
}
.stat-chip {
  display: flex;
  align-items: center;
  background: #e8f5e9;
  border: 1px solid #c8e6c9;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #2d8257;
  height: 38px;
}

/* Modern Card */
.modern-card {
  border-radius: 16px !important;
  border: 1px solid #ebebeb !important;
  overflow: hidden;
  background: #ffffff;
}

/* Card Toolbar / Filters */
.filters-bar {
  background: #ffffff;
}

/* Product Card Grid */
.product-grid-card {
  border: 1px solid #eaedf0 !important;
  border-radius: 12px !important;
  overflow: hidden;
  background: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.product-grid-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06) !important;
  border-color: #3ea56e44 !important;
}

/* Image Wrapper */
.product-img-wrap {
  position: relative;
  background: #f8fafc;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f1f5f9;
}
.product-image {
  transition: transform 0.3s ease;
}
.product-grid-card:hover .product-image {
  transform: scale(1.05);
}

/* Low Stock Badge */
.low-stock-badge-container {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;
}
.low-stock-badge {
  display: inline-flex;
  padding: 3px 8px;
  border-radius: 6px;
  background: linear-gradient(45deg, #FF5252, #FF1744);
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 4px rgba(255, 82, 82, 0.3);
}

/* Product info */
.product-info-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.product-name {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rating-wrap {
  display: flex;
}
.pricing-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
}
.regular-price-val {
  font-size: 14px;
  color: #1e293b;
}
.offer-price-val {
  font-size: 14px;
  color: #10b981;
}
.original-price-val {
  font-size: 11px;
  color: #ef4444;
  text-decoration: line-through;
}

/* Modern inputs */
.modern-input ::v-deep .v-input__slot {
  border-radius: 10px !important;
  font-size: 13px;
  border-color: #e2e8f0 !important;
}

/* Empty State */
.empty-state {
  padding: 64px 20px;
  text-align: center;
}
.empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #64748b;
  margin: 12px 0 4px;
}
.empty-subtitle {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

/* Pagination */
.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 14px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}
.pagination-info {
  font-size: 12px;
  color: #9e9e9e;
  font-weight: 500;
}
.modern-pagination ::v-deep .v-pagination__item {
  border-radius: 8px !important;
  font-size: 13px !important;
  min-width: 34px !important;
  height: 34px !important;
  box-shadow: none !important;
}
.modern-pagination ::v-deep .v-pagination__navigation {
  border-radius: 8px !important;
  box-shadow: none !important;
}
</style>
